"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var helpers_1 = require("../helpers");
var createElement_1 = __importDefault(require("./createElement"));
var NAMESPACE_TALPA = 'urn:x-cast:nl.talpavideo.caf';
var padToTwo = function (number) { return (number <= 9 ? "0".concat(number) : number); };
var convertToHHMMSS = function (totalSeconds) {
    var seconds = totalSeconds;
    var hours = padToTwo(Math.floor(totalSeconds / 3600));
    seconds %= 3600;
    var minutes = padToTwo(Math.floor(seconds / 60));
    seconds = padToTwo(seconds % 60);
    if (hours !== '00') {
        return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
    return "".concat(minutes, ":").concat(seconds);
};
var CafSender = (function () {
    function CafSender(_a) {
        var applicationId = _a.applicationId, autoJoinPolicy = _a.autoJoinPolicy, jwplayer = _a.jwplayer, videoApiEndpoint = _a.videoApiEndpoint, freewheelConfig = _a.freewheelConfig, playerChannel = _a.playerChannel, onDisconnect = _a.onDisconnect;
        this.isCasting = false;
        this.isPlayingBreak = false;
        this.playlistItem = null;
        this.timer = null;
        this.session = null;
        this.ccMenu = null;
        this.onInit = this.onInit.bind(this);
        this.initializeCastApi = this.initializeCastApi.bind(this);
        this.connectionChanged = this.connectionChanged.bind(this);
        this.playerStateChanged = this.playerStateChanged.bind(this);
        this.currentTimeChanged = this.currentTimeChanged.bind(this);
        this.volumeLevelChanged = this.volumeLevelChanged.bind(this);
        this.isMutedChanged = this.isMutedChanged.bind(this);
        if (autoJoinPolicy)
            this.autoJoinPolicy = autoJoinPolicy;
        this.applicationId = applicationId;
        this.jwplayer = jwplayer;
        this.videoApiEndpoint = videoApiEndpoint;
        this.freewheelConfig = freewheelConfig || null;
        this.playerChannel = playerChannel || null;
        if (onDisconnect)
            this.onDisconnect = onDisconnect;
        if (typeof cast !== 'undefined') {
            this.onInit(chrome.cast.isAvailable);
            return;
        }
        window['__onGCastApiAvailable'] = this.onInit;
        (0, helpers_1.createScript)('https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1');
    }
    CafSender.prototype.onInit = function (isAvailable) {
        var container = this.jwplayer.getContainer();
        if (isAvailable) {
            this.initializeCastApi();
            container.classList.add('jw-flag-cast-available');
            return;
        }
        container.classList.remove('jw-flag-cast-available');
    };
    CafSender.prototype.initializeCastApi = function () {
        var instance = cast.framework.CastContext.getInstance();
        instance.setOptions({
            receiverApplicationId: this.applicationId,
            autoJoinPolicy: this.autoJoinPolicy || chrome.cast.AutoJoinPolicy.PAGE_SCOPED,
        });
        this.jwplayer.addButton('', 'Chromecast', function () { }, 'cast-button');
        var launcher = document.createElement('google-cast-launcher');
        var castIcon = document.querySelector('[button="cast-button"] .jw-icon');
        if (castIcon) {
            castIcon.appendChild(launcher);
        }
        var castButton = document.querySelector('[button="cast-button"]');
        if (castButton) {
            castButton.style.display =
                instance.getCastState() === cast.framework.CastState.NO_DEVICES_AVAILABLE ? 'none' : 'flex';
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function () {
                    castButton.style.display = launcher.style.display === 'none' ? 'none' : 'flex';
                });
            });
            observer.observe(launcher, { attributes: true, attributeFilter: ['style'] });
        }
        this.remotePlayer = new cast.framework.RemotePlayer();
        this.remotePlayerController = new cast.framework.RemotePlayerController(this.remotePlayer);
        this.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED, this.connectionChanged);
        this.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.PLAYER_STATE_CHANGED, this.playerStateChanged);
        this.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED, this.currentTimeChanged);
        this.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.VOLUME_LEVEL_CHANGED, this.volumeLevelChanged);
        this.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.IS_MUTED_CHANGED, this.isMutedChanged);
    };
    CafSender.prototype.addOverlay = function (container) {
        var _this = this;
        var _a;
        var title = (0, createElement_1.default)('div', {
            className: 'title',
            innerText: this.session ? "Casten naar ".concat(this.session.getCastDevice().friendlyName) : '',
        });
        var playPauseToggle = (0, createElement_1.default)('div', {
            className: 'play-pause-toggle',
            onclick: function () {
                if (_this.remotePlayer.playerState === 'IDLE') {
                    _this.load();
                    return;
                }
                _this.remotePlayerController.playOrPause();
            },
        });
        playPauseToggle.setAttribute('role', 'button');
        var sliderContainer = (0, createElement_1.default)('div', {
            className: 'jw-slider-container',
            children: [
                (0, createElement_1.default)('div', { className: 'jw-rail' }),
                (0, createElement_1.default)('div', { className: 'jw-buffer' }),
                (0, createElement_1.default)('div', { className: 'jw-progress' }),
                (0, createElement_1.default)('div', { className: 'jw-knob' }),
            ],
        });
        var slider = (0, createElement_1.default)('div', {
            className: 'jw-slider-time jw-slider-horizontal',
            children: [sliderContainer],
            onclick: function (event) {
                var target = event.currentTarget;
                var width = target.offsetWidth;
                var position = event.offsetX;
                var duration = _this.remotePlayer.duration || _this.jwplayer.getPlaylistItem().duration;
                var seekTime = (position / width) * (duration || 1);
                _this.remotePlayer.currentTime = seekTime;
                _this.remotePlayerController.seek();
            },
        });
        var overlay = (0, createElement_1.default)('div', { className: 'cast-overlay', children: [title, playPauseToggle] });
        if (!((_a = this.playlistItem) === null || _a === void 0 ? void 0 : _a.isLive)) {
            overlay.append(slider);
        }
        container.appendChild(overlay);
    };
    CafSender.prototype.removeCCMenu = function () {
        if (!this.ccMenu)
            return;
        this.ccMenu.remove();
        this.ccMenu = null;
    };
    CafSender.prototype.addCCMenu = function () {
        var _this = this;
        var captions = this.jwplayer.getCaptionsList();
        if (!(captions === null || captions === void 0 ? void 0 : captions.length))
            return;
        var options = captions.map(function (track) {
            return (0, createElement_1.default)('div', {
                className: _this.currentTrack === track.id || _this.currentTrack === track.label
                    ? "cast-cc-item cast-cc-item-active"
                    : "cast-cc-item",
                innerText: track.label,
                onclick: function () {
                    _this.setActiveTrack(track.id.toString());
                    _this.setJWCaption(track.id.toString());
                    _this.removeCCMenu();
                },
            });
        });
        this.ccMenu = (0, createElement_1.default)('div', {
            className: 'cast-cc-menu',
            children: options,
        });
        var container = this.jwplayer.getContainer();
        container.append(this.ccMenu);
    };
    CafSender.prototype.updateCCIcon = function (id) {
        var container = this.jwplayer.getContainer();
        if (id === 'off') {
            container.classList.add('cc-disabled');
            return;
        }
        container.classList.remove('cc-disabled');
    };
    CafSender.prototype.addCCButton = function () {
        var _this = this;
        this.jwplayer.addButton('', 'Ondertiteling', function () {
            if (_this.ccMenu) {
                return _this.removeCCMenu();
            }
            _this.addCCMenu();
        }, 'cast-cc-button');
    };
    CafSender.prototype.removeCCButton = function () {
        this.jwplayer.removeButton('cast-cc-button');
    };
    CafSender.prototype.connectionChanged = function (_a) {
        var _this = this;
        var connected = _a.value;
        var container = this.jwplayer.getContainer();
        if (connected) {
            this.isCasting = true;
            this.jwplayer.pause();
            this.load();
            container.classList.add('jw-flag-casting');
            this.session = cast.framework.CastContext.getInstance().getCurrentSession();
            if (this.session) {
                this.session.addMessageListener('urn:x-cast:nl.talpavideo.caf', function (namespace, message) {
                    var _a = JSON.parse(message), type = _a.type, rest = __rest(_a, ["type"]);
                    if (type === 'LOG') {
                        console.log.apply(console, __spreadArray(['[CAF log]'], rest.message, false));
                        return;
                    }
                    if (type === 'TRACK_CHANGED') {
                        return _this.setJWCaption(rest.id);
                    }
                    if (type === 'BREAK_TIME_UPDATE') {
                        return _this.incrementMediaTime(rest.value, rest.duration);
                    }
                    if (type === 'ON_BREAK_CHANGED') {
                        return _this.onBreakChange(__assign({ isPlayingBreak: rest.value }, rest));
                    }
                    console.log(namespace, JSON.parse(message));
                });
            }
            this.addOverlay(container);
            return;
        }
        this.isCasting = false;
        if (this.onDisconnect) {
            this.onDisconnect();
        }
        this.session = null;
        container.classList.remove('jw-flag-casting', 'jw-cast-playing', 'jw-cast-paused');
        var overlay = document.querySelector('.cast-overlay');
        if (overlay)
            overlay.remove();
        this.removeCCMenu();
    };
    CafSender.prototype.playerStateChanged = function (_a) {
        var _b;
        var state = _a.value;
        var container = this.jwplayer.getContainer();
        var stateClasses = ['jw-cast-paused', 'jw-cast-playing', 'jw-cast-idle', 'jw-cast-buffering'];
        var stateClass = '';
        if (state === 'PAUSED')
            stateClass = 'jw-cast-paused';
        if (state === 'BUFFERING')
            stateClass = 'jw-cast-buffering';
        if (state === 'PLAYING')
            stateClass = 'jw-cast-playing';
        if (state === 'IDLE')
            stateClass = 'jw-cast-paused';
        (_b = container.classList).remove.apply(_b, stateClasses.filter(function (value) { return value !== stateClass; }));
        container.classList.add(stateClass);
    };
    CafSender.prototype.volumeLevelChanged = function (_a) {
        var volumeLevel = _a.value;
        this.jwplayer.setVolume(Math.round(volumeLevel * 100));
    };
    CafSender.prototype.currentTimeChanged = function (_a) {
        var currentTime = _a.value;
        this.currentTime = currentTime;
        if (this.isPlayingBreak)
            return;
        this.incrementMediaTime(currentTime, this.remotePlayer.duration);
    };
    CafSender.prototype.isMutedChanged = function (_a) {
        var isMuted = _a.value;
        this.jwplayer.setMute(isMuted);
    };
    CafSender.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var container, source, mediaInfo, captionLabel, customData, _a, sectionid, profileid, networkid, serverid, custom, vdur, talpa_consent, embed_domain, _fw_gdpr_consent, _fw_gdpr, csid, request, session;
            var _this = this;
            var _b, _c;
            return __generator(this, function (_d) {
                container = this.jwplayer.getContainer();
                container.classList.add('jw-cast-buffering');
                this.playlistItem = this.jwplayer.getPlaylistItem();
                source = this.playlistItem.allSources.find(function (source) { var _a; return source.type === 'dash' && (source.drm === null || !!((_a = source.drm) === null || _a === void 0 ? void 0 : _a.widevine)); }) || ((_b = this.playlistItem.sources) === null || _b === void 0 ? void 0 : _b[0]);
                mediaInfo = new chrome.cast.media.MediaInfo(this.playlistItem.guid, 'video/mp4');
                mediaInfo.streamType = chrome.cast.media.StreamType.BUFFERED;
                mediaInfo.contentUrl = source === null || source === void 0 ? void 0 : source.file;
                mediaInfo.metadata = new chrome.cast.media.TvShowMediaMetadata();
                mediaInfo.metadata.title = this.playlistItem.title || this.playlistItem.SeriesTitle;
                mediaInfo.metadata.subtitle = this.playlistItem.seriesTitle || this.playlistItem.Subtitle;
                mediaInfo.metadata.images = [
                    {
                        url: this.playlistItem.image,
                    },
                ];
                mediaInfo.metadata.posterUrl = this.playlistItem.image;
                if ((_c = this.playlistItem.tracks) === null || _c === void 0 ? void 0 : _c.length) {
                    this.addCCButton();
                    captionLabel = localStorage.getItem('jwplayer.captionLabel');
                    this.currentTrack =
                        captionLabel || this.playlistItem.tracks.some(function (track) { return track.label === constants_1.CAPTION_DUTCH; }) ? constants_1.CAPTION_DUTCH : 'off';
                }
                else {
                    this.currentTrack = 'off';
                    this.removeCCButton();
                }
                this.updateCCIcon(this.currentTrack);
                customData = {
                    currentTrack: this.currentTrack,
                    sendAdUpdates: true,
                    playerChannel: this.playerChannel,
                    videoApiEndpoint: this.videoApiEndpoint,
                };
                if (this.freewheelConfig) {
                    _a = this.freewheelConfig, sectionid = _a.sectionid, profileid = _a.profileid, networkid = _a.networkid, serverid = _a.serverid, custom = _a.custom;
                    vdur = custom.vdur, talpa_consent = custom.talpa_consent, embed_domain = custom.embed_domain, _fw_gdpr_consent = custom._fw_gdpr_consent, _fw_gdpr = custom._fw_gdpr;
                    csid = sectionid.replace(/_desktop.*|_mobile.*|_android.*|_ios.*|_app/, '_chromecast');
                    customData.freewheelConfig = {
                        adRequestURL: serverid,
                        globalParams: {
                            prof: profileid,
                            nw: networkid,
                            csid: csid,
                            vdur: vdur,
                        },
                        keyValues: { talpa_consent: talpa_consent, embed_domain: embed_domain, _fw_gdpr_consent: _fw_gdpr_consent, _fw_gdpr: _fw_gdpr },
                    };
                }
                mediaInfo.customData = customData;
                request = new chrome.cast.media.LoadRequest(mediaInfo);
                this.currentTime = 0;
                request.currentTime = this.currentTime;
                request.autoplay = true;
                session = cast.framework.CastContext.getInstance().getCurrentSession();
                if (!session)
                    return [2];
                session.loadMedia(request).then(function () {
                    var _a;
                    if ((_a = _this.playlistItem) === null || _a === void 0 ? void 0 : _a.isLive) {
                        container.classList.add('jw-flag-casting-live');
                    }
                    else {
                        container.classList.remove('jw-flag-casting-live');
                    }
                    _this.jwplayer.setMute(_this.remotePlayer.isMuted);
                    _this.jwplayer.setVolume(Math.round(_this.remotePlayer.volumeLevel * 100));
                }, function (errorCode) {
                    console.log('Remote media load error: ' + errorCode);
                });
                return [2];
            });
        });
    };
    CafSender.prototype.sendMessage = function (message) {
        if (!this.session)
            return;
        this.session.sendMessage(NAMESPACE_TALPA, JSON.stringify(message));
    };
    CafSender.prototype.setActiveTrack = function (id) {
        if (this.currentTrack === id)
            return;
        this.sendMessage({
            type: 'SET_ACTIVE_TRACK',
            value: id,
        });
    };
    CafSender.prototype.setJWCaption = function (id) {
        this.currentTrack = id;
        this.updateCCIcon(id);
        var captions = this.jwplayer.getCaptionsList();
        var index = captions.findIndex(function (caption) { return caption.id === id; });
        if (this.jwplayer.getState() === 'idle') {
            localStorage.setItem('jwplayer.captionLabel', captions[index].label);
            return;
        }
        this.jwplayer.setCurrentCaptions(index);
    };
    CafSender.prototype.setMute = function (mute) {
        if (mute !== this.remotePlayer.isMuted) {
            this.remotePlayerController.muteOrUnmute();
        }
    };
    CafSender.prototype.setVolume = function (volume) {
        if (volume !== this.remotePlayer.volumeLevel) {
            this.remotePlayer.volumeLevel = volume;
            this.remotePlayerController.setVolumeLevel();
        }
    };
    CafSender.prototype.incrementMediaTime = function (currentTime, duration) {
        if (typeof currentTime === 'undefined' || typeof duration === 'undefined')
            return;
        var percent = "".concat((Math.floor(currentTime) / Math.floor(duration)) * 100, "%");
        var elapsedTimeElement = document.querySelector('.jw-text-elapsed');
        if (elapsedTimeElement)
            elapsedTimeElement.innerText = convertToHHMMSS(Math.floor(currentTime));
        var durationContainer = document.querySelector('.jw-text-duration');
        if (durationContainer)
            durationContainer.innerText = convertToHHMMSS(Math.floor(duration));
        var progress = document.querySelector('.cast-overlay .jw-progress');
        if (progress)
            progress.style.width = percent;
        var knob = document.querySelector(".cast-overlay .jw-knob");
        if (knob)
            knob.style.left = percent;
    };
    CafSender.prototype.onBreakChange = function (_a) {
        var _this = this;
        var isPlayingBreak = _a.isPlayingBreak, duration = _a.duration, podcount = _a.podcount, sequence = _a.sequence, breaks = _a.breaks;
        this.isPlayingBreak = isPlayingBreak;
        document.querySelectorAll('.jw-cuepoints, .jw-ad-text').forEach(function (element) { return element.remove(); });
        var container = this.jwplayer.getContainer();
        if (isPlayingBreak) {
            var castOverlay = document.querySelector('.cast-overlay');
            if (castOverlay && podcount && sequence) {
                castOverlay.appendChild((0, createElement_1.default)('div', { className: 'jw-ad-text', innerText: "Reclame ".concat(sequence, " van ").concat(podcount) }));
            }
            this.incrementMediaTime(0, duration);
            container.classList.add('jw-cast-ad-break');
            return;
        }
        this.incrementMediaTime(this.currentTime, this.remotePlayer.duration);
        container.classList.remove('jw-cast-ad-break');
        var sliderContainer = document.querySelector('.cast-overlay .jw-slider-container');
        if (sliderContainer) {
            var cuePoints = breaks.map(function (_a) {
                var position = _a.position;
                var left = '';
                if (position === 0)
                    left = '0';
                else if (position === -1)
                    left = '100%';
                else
                    left = "".concat(Math.floor((position / _this.remotePlayer.duration) * 100), "%");
                var cuePoint = (0, createElement_1.default)('div', { className: 'jw-cuepoint' });
                cuePoint.style.left = left;
                return cuePoint;
            });
            sliderContainer.appendChild((0, createElement_1.default)('div', { className: 'jw-cuepoints', children: cuePoints }));
        }
    };
    return CafSender;
}());
exports.default = CafSender;
